<template>
  <NuxtLink :to="`agent?startq=${query}`"  target="_blank">
    <div class="group relative overflow-hidden rounded-xl cursor-pointer my-3 mx-0 md:mx-0">
      <div
        class="absolute -inset-px rounded-xl bg-gradient-to-r from-purple-600 via-fuchsia-600 to-pink-500 opacity-80 transition-opacity duration-500"
      />
      <div class="relative p-3">
        <div class="w-full grid grid-cols-[15%_75%_10%] md:grid-cols-[10%_80%_10%] items-center">
          <!-- Maon Large Icon -->
          <div
            class="flex items-center justify-center rounded-lg aspect-square bg-gradient-to-br from-pink-500 via-fuchsia-600 to-purple-500 shadow-md shadow-fuchsia-500/20 transition-all duration-300 group-hover:shadow-fuchsia-500/30 group-hover:scale-[1.05]"
          >
          <img src="/img/icons/ts_heart.svg" alt="TourScanner AI" class="w-6 h-6 mx-auto filter brightness-0 invert"
          />
          </div>

          <!-- Main Text - Header -->
          <div class="flex flex-col min-w-0 pl-2 md:pl-4">
            <div class="flex items-center gap-2">
              <text class="text-lg md:text-xl font-semibold text-purple-100 tracking-tight"> AI Travel Assistant </text>
              <span
                class="inline-flex leading-none items-center h-fit gap-0.5 px-2 py-0.5 text-[0.65rem] font-medium bg-gradient-to-r from-fuchsia-100 to-violet-100 dark:from-fuchsia-900/30 dark:to-violet-900/30 text-fuchsia-700 dark:text-fuchsia-300 rounded-full border border-fuchsia-200/60 dark:border-fuchsia-700/60"
              >
                <Icon name="lucide:sparkles" class="w-2.5 h-2.5" />
                NEW
              </span>
            </div>

            <text v-if="query" class="text-sm md:text-md text-white leading-snug mb-2">
              Ask 
              <span class="font-bold text-white underline bg-clip-text">"{{ props.query }}"</span>
            </text>
            <text v-else class="text-xs md:text-md text-white leading-snug mb-2">
              Let our AI assistant simplify your travel.
            </text>
          </div>

          <!-- Right Arrow -->
          <div class="self-center justify-self-end">
            <div
              class="w-8 h-8 rounded-full flex items-center justify-center bg-gradient-to-r from-fuchsia-100 to-violet-100 dark:from-fuchsia-900/30 dark:to-violet-900/30 text-fuchsia-700 dark:text-fuchsia-300 border border-fuchsia-200/60 dark:border-fuchsia-700/60"
            >
              <Icon name="lucide:arrow-right" class="w-4 h-4 text-purple transition-transform duration-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  query: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
@keyframes sweep {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes float {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-4px) rotate(1deg);
  }
  100% {
    transform: translateY(0px) rotate(0deg);
  }
}
</style>
